import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Force the window to scroll to the top whenever the route changes —
// so navigating between pages always starts at the top, not where the
// previous page was scrolled to.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
